import React from 'react';
import { Search, User, Gamepad2 } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  searchType: 'game' | 'user';
  onSearchTypeChange: (type: 'game' | 'user') => void;
  onSubmit: (e: React.FormEvent) => void;
  placeholder?: string;
}

export function SearchBar({ 
  value, 
  onChange, 
  searchType,
  onSearchTypeChange,
  onSubmit,
  placeholder 
}: SearchBarProps) {
  return (
    <form onSubmit={onSubmit} className="relative">
      <div className="flex gap-2 mb-3">
        <button
          type="button"
          onClick={() => onSearchTypeChange('game')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            searchType === 'game'
              ? 'bg-indigo-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Gamepad2 className="w-4 h-4" />
          <span>Steam Games</span>
        </button>
        <button
          type="button"
          onClick={() => onSearchTypeChange('user')}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
            searchType === 'user'
              ? 'bg-indigo-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <User className="w-4 h-4" />
          <span>Steam Users</span>
        </button>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder={placeholder || `Search ${searchType === 'game' ? 'Steam games' : 'Steam users'}...`}
        />
      </div>
    </form>
  );
}